<template>
  <v-table
      :count="count"
      :list="list"
      :query-list="queryList"
      :is-loading="isLoading"
      :push-list="RouteConfig.errorWeChatOrderList.push"
      :is-show-search-input="false"
  >
    <v-column-time/>
    <el-table-column label="日志 ID" prop="id" width="100px"/>
    <v-column-student label="所属学员" link-page-id="student_id"/>
    <el-table-column label="错误类型" width="130px">
      <template v-slot="{ row }">
        <el-tag v-for="apiErrorType in findApiErrorType(row.error_type)" :type="apiErrorType.tagType" :key="`apiErrorType${apiErrorType.value}`">
          {{ apiErrorType.name }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="状态码" prop="status_code"/>
    <el-table-column label="错误消息" prop="error_message">
      <template slot-scope="{ row }">
        <div class="overflow-box">{{ row.error_message }}</div>
      </template>
    </el-table-column>
    <el-table-column label="错误内容" prop="response_body">
      <template slot-scope="{ row }">
        <div class="overflow-box">{{ row.response_body }}</div>
      </template>
    </el-table-column>
    <el-table-column label="订单号" prop="out_trade_no"/>
    <el-table-column label="请求类型" width="130px">
      <template v-slot="{ row }">
        <el-tag v-for="requestType in findRequestType(row.request_type)" :type="requestType.tagType" :key="`requestType${requestType.value}`">
          {{ requestType.name }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.errorLogWeChatOrderDetail.to(row.id)" icon="browse" name="查看"/>
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`error-we-chat-order-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>日志 ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>所属学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>错误类型</span>
              <div class="list-item-info">
                <el-tag
                  v-for="apiErrorType in findApiErrorType(v.error_type)"
                  :key="`mobile-api-error-type-${v.id}-${apiErrorType.value}`"
                  :type="apiErrorType.tagType"
                >
                  {{ apiErrorType.name }}
                </el-tag>
              </div>
            </div>
            <div class="list-item-detail">
              <span>状态码</span>
              <span>{{ v.status_code }}</span>
            </div>
            <div class="list-item-detail">
              <span class="flex-shrink">错误消息</span>
              <span class="list-item-info">{{ `${v.error_message}${v.error_message && v.error_message.length > 31 ? '……' : ''}` }}</span>
            </div>
            <div class="list-item-detail">
              <span class="flex-shrink">错误内容</span>
              <span class="list-item-info">{{ `${v.response_body}${v.response_body && v.response_body.length > 31 ? '……' : ''}` }}</span>
            </div>
            <div class="list-item-detail">
              <span>订单号</span>
              <span>{{ v.out_trade_no }}</span>
            </div>
            <div class="list-item-detail">
              <span>请求类型</span>
              <div class="list-item-info">
                <el-tag
                  v-for="requestType in findRequestType(v.request_type)"
                  :key="`mobile-request-type-${v.id}-${requestType.value}`"
                  :type="requestType.tagType"
                >
                  {{ requestType.name }}
                </el-tag>
              </div>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.errorLogWeChatOrderDetail.to(v.id)" icon="browse" name="查看"/>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { findApiErrorType } from '@/enums/apiErrorTypes';
import { findRequestType } from '@/enums/weChatPayRequestTypes';
import { getLegalQueryList } from '@/utils/formats';
import { getWeChatOrderList } from '@/api/error-log';

export default {
  name: RouteConfig.errorWeChatOrderList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findApiErrorType,
    findRequestType,
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await getWeChatOrderList(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
<style src="./index.css" scoped/>
